import { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  TimesheetPageShiftFragment,
  UpdateAttendanceShiftMutationVariables,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import ClockedIn from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyTable/DayRow/ShiftPanelTableBody/ShiftRow/ClockedIn'
import TimeInput from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyTable/DayRow/ShiftPanelTableBody/ShiftRow/TimeInput'

interface ClockInProps {
  form: FormikProps<UpdateAttendanceShiftMutationVariables>
  readonly?: boolean
  isUnresolved?: boolean
  inputBorderStyle?: ComponentProps<typeof Box>['border']
}

interface ClockOutProps {
  shift: TimesheetPageShiftFragment
  readonly?: boolean
  form: FormikProps<UpdateAttendanceShiftMutationVariables>
  showClockOutInput: boolean
  isUnresolved?: boolean
  inputBorderStyle?: ComponentProps<typeof Box>['border']
}

export const ClockIn = observer(
  ({ form, readonly, isUnresolved = false, inputBorderStyle }: ClockInProps) => (
    <TimeInput
      value={form.values.clockIn}
      readonly={!!readonly}
      isNotValid={isUnresolved}
      inputBorderStyle={inputBorderStyle}
      onChange={(value) => {
        form.setValues({ ...form.values, clockIn: value })
        form.initialValues.clockIn !== value
          ? form.setFieldTouched('clockIn', true)
          : form.setFieldTouched('clockIn', false)
      }}
    />
  )
)

export const ClockOut = observer(
  ({
    form,
    readonly,
    shift,
    showClockOutInput,
    isUnresolved = false,
    inputBorderStyle,
  }: ClockOutProps) => {
    if (showClockOutInput) {
      return (
        <TimeInput
          value={form.values.clockOut}
          readonly={!!readonly}
          isNotValid={isUnresolved}
          inputBorderStyle={inputBorderStyle}
          onChange={(value) => {
            form.setValues({ ...form.values, clockOut: value })
            form.initialValues.clockOut !== value
              ? form.setFieldTouched('clockOut', true)
              : form.setFieldTouched('clockOut', false)
          }}
        />
      )
    }

    return <ClockedIn workable={!!shift.workable} />
  }
)
